import { render } from "./DropdownTeamManager.vue?vue&type=template&id=51e9dad8"
import script from "./DropdownTeamManager.vue?vue&type=script&lang=js"
export * from "./DropdownTeamManager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__